/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A Vikimap service module to use for a Vikimap driven application. Supports Accedo One, JSON and Middleware services. (@accedo/vdkweb-vikimap) 4.0.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _find = _interopRequireDefault(require("lodash/find"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable no-throw-literal, prefer-promise-reject-errors */
var JsonEntryProvider = /*#__PURE__*/function () {
  function JsonEntryProvider(json) {
    _classCallCheck(this, JsonEntryProvider);
    this.json = json;
  }
  _createClass(JsonEntryProvider, [{
    key: "getEntryById",
    value:
    /**
     * Retrieves an entry by ID from the list of entries
     * in the provided JSON structure.
     *
     * @param  {string} id   The ID for the entry to fetch
     * @return {Promise}     A promise resolving with the entry
     */
    function getEntryById(id) {
      return this.getAllEntries().then(function (entries) {
        var entry = entries[id];
        if (!entry) {
          throw {
            id: id,
            error: "Entry with ID: ".concat(id, " doesn't exist")
          };
        }
        return entry;
      });
    }

    /**
     * Retrieves a list of entries by an array of IDS from the list of entries
     * in the provided JSON structure.
     *
     * @param  {array} ids   An array of IDs for the entries to fetch
     * @return {Promise}     A promise resolving with the list of entries
     */
  }, {
    key: "getEntriesByIds",
    value: function getEntriesByIds(ids) {
      var _this = this;
      var entries = ids.map(function (id) {
        return _this.getEntryById(id);
      });
      return Promise.all(entries);
    }

    /**
     * Retrieves an entry by alias from the list of entries
     * in the provided JSON structure.
     *
     * @param  {string} alias   The alias of the entry to fetch
     * @return {Promise}        A promise resolving with the entry
     */
  }, {
    key: "getEntryByAlias",
    value: function getEntryByAlias(alias) {
      return this.getAllEntries().then(function (entries) {
        var entry = (0, _find["default"])(entries, function (entryObj) {
          return entryObj.alias === alias || entryObj._meta.entryAlias === alias;
        });
        if (!entry) {
          throw {
            alias: alias,
            error: "Entry with alias: ".concat(alias, " doesn't exist")
          };
        }
        return entry;
      });
    }

    /**
     * Retrieves a list of entries by an array of aliases from the list of entries
     * in the provided JSON structure.
     *
     * @param  {array} aliases   An array of aliases for the entries to fetch
     * @return {Promise}         A promise resolving with the list of entries
     */
  }, {
    key: "getEntriesByAliases",
    value: function getEntriesByAliases(aliases) {
      var _this2 = this;
      var entries = aliases.map(function (alias) {
        return _this2.getEntryByAlias(alias);
      });
      return Promise.all(entries);
    }

    /**
     * Returns all entries available.
     * @return {array}   List of all entries
     */
  }, {
    key: "getAllEntries",
    value: function getAllEntries() {
      if (this.entryMapPromise) {
        return this.entryMapPromise;
      }
      if (!this.json) {
        return Promise.reject('No JSON file has been provided. Call init(json) to set it.');
      }
      if (typeof this.json.then === 'function') {
        this.entryMapPromise = this.json.then(function (data) {
          if (!data) {
            throw {
              error: 'Promise did not return any entries.'
            };
          }
          var entries = _typeof(data.entries) === 'object' ? data.entries : data;
          return JsonEntryProvider.createEntryMap(entries);
        });
      } else {
        var entries = _typeof(this.json.entries) === 'object' ? this.json.entries : this.json;
        if (!entries) {
          return Promise.reject('Entries were not properly initialised. Provide an array or an object with an "entries" property containing an array of entries.');
        }
        this.entryMapPromise = Promise.resolve(JsonEntryProvider.createEntryMap(entries));
      }
      return this.entryMapPromise;
    }
  }], [{
    key: "createEntryMap",
    value: function createEntryMap(entries) {
      var map = {};
      entries.forEach(function (entry) {
        map[entry._meta.id] = _objectSpread(_objectSpread({}, entry), {}, {
          id: entry._meta.id,
          alias: entry._meta.entryAlias
        });
      });
      return map;
    }
  }]);
  return JsonEntryProvider;
}();
var _default = JsonEntryProvider;
/* eslint-enable no-throw-literal, prefer-promise-reject-errors */
exports["default"] = _default;